export default "<main>\n  <router-outlet></router-outlet>\n  </main>"